// extracted by mini-css-extract-plugin
export default {"tablechange":"list_tablechange__2RaLB","mobileTopAlign":"list_mobileTopAlign__u867+"};